<div class="container">
  <button (click)="login()" class="btn btn-primary">Login</button>
</div>